<template>
    <footer class="footer">
         &copy; 2022 Corendon Airlines. All Rights Reserved. <br/>
    </footer>
</template>

<script>
    export default {
        name: "AppFooter",
    }
</script>

<style scoped>
    footer {
        text-align: center;
        font-weight: 600;
        font-size: 12px;
        /*position:fixed;*/
        bottom:0;
        width:100%;
        text-align:center;
    }
</style>
